export default {
    name: 'AdsSelector',
    props: {
        path: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            viewMode: null,
            options: [
                {label: this.$t('lang.group_report.all'), value: ''},
                {label: this.$t('lang.group_report.unique_links'), value: '&view=links'},
                {label: this.$t('lang.group_report.unique_facts'), value: '&view=facts'},
            ],
        }
    },
    methods: {
        onChangeMode() {
            window.open(sprintf('%s?page=ads%s', this.path, this.viewMode), '_self');
        },
    },
}
